import { modalController } from '@ionic/core';
import { Component, Event, EventEmitter, Fragment, h, Prop } from '@stencil/core';
import { PersonDoc } from 'common';
import { PeopleService } from '../../global/service/PeopleService';

@Component({
  tag: 'team-info-modal',
})
export class TeamInfoModal {
  static async present(people: PersonDoc[]): Promise<void> {
    const modal = await modalController.create({
      component: 'team-info-modal',
      cssClass: 'concourse-modal modal-height-auto',
      componentProps: { people },
    });

    modal.addEventListener('dismiss', () => {
      modal.dismiss();
    });

    return await modal.present();
  }

  @Prop() people: PersonDoc[];
  @Event() dismiss: EventEmitter;

  render() {
    return (
      <Fragment>
        <ion-header>
          <ion-toolbar>
            <ion-title>{this.people.length} people</ion-title>
            <ion-buttons slot="end">
              <ion-button onClick={() => this.dismiss.emit()}>
                <ion-icon slot="icon-only" name="close"></ion-icon>
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-page class="ion-padding">
          <ion-grid>
            {this.people.slice(0, 2).map(person => (
              <ion-row>
                <ion-col size="auto">
                  <ion-avatar>
                    <img src={PeopleService.getIcon(person)} />
                  </ion-avatar>
                </ion-col>
                <ion-col>
                  <ion-title>{PeopleService.getFullName(person)}</ion-title>
                  <div class="small-super-script">email</div>
                  <p>{person.email}</p>
                  <div class="small-super-script ">Company</div>
                  <p>
                    {person.company_role} at {person.company}
                  </p>
                </ion-col>
              </ion-row>
            ))}
          </ion-grid>
        </ion-page>
      </Fragment>
    );
  }
}
